module.exports = __webpack_public_path__ + "1fdb3615faabbb0371e8e59fb44dbd36.svg";